module.exports = __webpack_public_path__ + "img/logement-etage-intermediaire.f3712b90.png";